import { createI18nText } from '@hilma/netina2all';

const alts = createI18nText({
	he: {
		latetLogo: 'לוגו לתת לולב',
		associationLogo: 'לוגו של עמותה',
		donatedBg: 'רקע',
		arrow: 'חץ',
		steps: {
			mishloachManot: 'משלוח מנות',
			heartHandShake: 'לחיצת יד ולב',
			locationMarker: 'סימון מקום',
			shekel: 'אייקון שקלים',
		},
		fbIcon: 'אייקון של פייסבוק',
		recommender: 'תמונה של ממליץ',
		branches: 'ענפים',
		siteMap: {
			thumbsUp: 'אגודל למעלה',
			netLogo: 'לוגו לתת לולב',
			enterProfile: 'כניסה לאזור האישי',
			giveHeart: 'יד עם לב',
			locations: 'מפה עם סימוני מקום',
			addHeart: 'לב עם פלוס',
			addLocation: 'סימון מקום עם פלוס'
		},
		profileIcon: 'אייקון פרופיל',
		addHeart: 'לב עם פלוס',
		envelope: 'מעטפה',
		search: 'אייקון חיפוש',
		whyUs: {
			sparkles: 'נצנצים',
			certificate: 'אישור',
			heartChest: 'אדם עם לב '
		},
		expandAccordionArrow: 'חץ להצגת התשובה',
		showInfo: 'הראה יותר או הראה פחות',
		accessible: 'התחנה נגישה',
		stationImage: 'תמונה של התחנה',
		locationMarker: 'מסמן מקום',
		imageOfPerson: 'תמונה של אדם',
		purchase: 'לרכישה',
		showMenu: 'הראה תפריט',
		associationReg: {
			document: 'מסמך',
			manager: 'מנהל',
			heart: 'נתינה',
		},
		closeMenu: 'סגור תפריט',
		payment: {
			pen: 'עט',
			station: 'תחנה',
			page: 'דף'
		}
	},
	en: {
		latetLogo: 'Latet Lulav logo',
		associationLogo: 'Association logo',
		donatedBg: 'Background',
		arrow: 'Arrow',
		steps: {
			mishloachManot: 'Mishloach Manot',
			heartHandShake: 'Hand shake inside a heart',
			locationMarker: 'Location marker',
			shekel: 'Shekel icon',
		},
		fbIcon: 'Facebook icon',
		recommender: 'Image of recommender',
		branches: 'Branches',
		siteMap: {
			thumbsUp: 'Thumbs up',
			netLogo: 'Latet Lulav logo',
			giveHeart: 'Hand with heart',
			locations: 'Map with location plots',
			addHeart: 'Heart with plus',
			addLocation: 'Location pin with plus',
			enterProfile: 'user profile'
		},
		profileIcon: 'Profile icon',
		addHeart: 'Heart with plus',
		envelope: 'Envelope',
		search: 'Search icon',
		whyUs: {
			sparkles: 'Sparkles',
			certificate: 'Certificate',
			heartChest: 'Person with heart'
		},
		expandAccordionArrow: 'Arrow to show answer',
		showInfo: 'Show more info or hide more info',
		accessible: 'The station is accessible',
		stationImage: 'Image of the station',
		locationMarker: 'location marker',
		imageOfPerson: 'Picture of a person',
		purchase: 'Purchase',
		showMenu: 'Show menu',
		associationReg: {
			document: 'Document',
			manager: 'Manager',
			heart: 'Giving hand',
		},
		closeMenu: 'Close menu',
		payment: {
			pen: 'pen',
			station: 'station',
			page: 'page'
		}
	}
});

export default alts;